import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconError = function IconError(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.87l3.93-3.94 1.14 1.14L11.13 10l3.94 3.93-1.14 1.14L10 11.13l-3.93 3.94-1.14-1.14L8.87 10 4.93 6.07l1.14-1.14L10 8.87z",
    fill: "#000"
  }));
};

export { IconError };